var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.751C22.5 15.165 22.164 15.501 21.75 15.501H15.5V21.751C15.5 22.165 15.164 22.501 14.75 22.501C14.336 22.501 14 22.165 14 21.751V15.501H7.75C7.336 15.501 7 15.165 7 14.751C7 14.337 7.336 14.001 7.75 14.001H14V7.75098C14 7.33698 14.336 7.00098 14.75 7.00098C15.164 7.00098 15.5 7.33698 15.5 7.75098V14.001H21.75C22.164 14.001 22.5 14.337 22.5 14.751Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3740d6c5c2e298bee1a219d5ad000926.svg";
export { ForwardRef as ReactComponent };